import { useState } from 'react'
import axios from 'axios'
import { CreditCard, LoaderCircle } from 'lucide-react'

export default function CheckoutInfinitePay({ pedidoId, total }) {
  const [carregando, setCarregando] = useState(false)
  const [erro, setErro] = useState('')

  const iniciarPagamento = async () => {
    setCarregando(true)
    setErro('')
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/pagamento/infinitepay/link`,
        { pedidoId, totalPedido: Number(total) }
      )
      if (!data?.url) throw new Error('A InfinitePay não retornou o link de pagamento.')
      window.location.assign(data.url)
    } catch (error) {
      setErro(error?.response?.data?.error || error?.message || 'Não foi possível iniciar o pagamento. Tente novamente.')
      setCarregando(false)
    }
  }

  return (
    <section className="infinitepay-checkout" aria-live="polite" style={{ maxWidth: 520, margin: '20px auto', padding: 24, border: '1px solid #e7eaf0', borderRadius: 16, background: '#fff', textAlign: 'center', boxShadow: '0 8px 28px rgba(16,24,40,.06)' }}>
      <p style={{ color: '#475467', lineHeight: 1.5 }}>Você será direcionado ao checkout seguro da InfinitePay para concluir o pagamento com cartão.</p>
      {erro && <p role="alert" style={{ color: '#b42318', margin: '12px 0' }}>{erro}</p>}
      <button type="button" onClick={iniciarPagamento} disabled={carregando || !pedidoId} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 9, width: '100%', minHeight: 48, border: 0, borderRadius: 10, background: '#155eef', color: '#fff', fontWeight: 700, cursor: carregando ? 'wait' : 'pointer', opacity: carregando ? .75 : 1 }}>
        {carregando ? <><LoaderCircle size={18} className="spin" /> Gerando pagamento…</> : <><CreditCard size={18} /> Pagar com cartão</>}
      </button>
      <small style={{ display: 'block', marginTop: 12, color: '#667085' }}>O pedido será confirmado automaticamente após a validação do pagamento.</small>
    </section>
  )
}
